import { render } from "./ArticlesScreen.vue?vue&type=template&id=9cf53fb0"
import script from "./ArticlesScreen.vue?vue&type=script&lang=js"
export * from "./ArticlesScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__